(() => {
  // Collect all linked images in .rte content
  function getImages(rte) {
    return Array.from(rte.querySelectorAll('a > img')).filter(img => {
      const href = img.parentElement.href || '';
      return /\.(jpe?g|png|gif|webp|avif|svg)(\?|$)/i.test(href);
    });
  }

  function buildLightbox() {
    const overlay = document.createElement('div');
    overlay.className = 'lb-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Prohlížeč obrázků');

    overlay.innerHTML = `
      <button class="lb-close" aria-label="Zavřít">
        <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      <button class="lb-arrow lb-arrow--prev" aria-label="Předchozí">
        <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
      <div class="lb-img-wrap">
        <img src="" alt="">
      </div>
      <button class="lb-arrow lb-arrow--next" aria-label="Další">
        <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
      <div class="lb-counter"></div>
    `;

    document.body.appendChild(overlay);
    return overlay;
  }

  function init(rte) {
    const images = getImages(rte);
    if (!images.length) return;

    const overlay = buildLightbox();
    const imgEl = overlay.querySelector('.lb-img-wrap img');
    const closeBtn = overlay.querySelector('.lb-close');
    const prevBtn = overlay.querySelector('.lb-arrow--prev');
    const nextBtn = overlay.querySelector('.lb-arrow--next');
    const counter = overlay.querySelector('.lb-counter');

    let current = 0;

    function show(index) {
      current = (index + images.length) % images.length;
      const src = images[current].parentElement.href;
      const alt = images[current].alt || '';

      imgEl.classList.add('lb-loading');
      const tmp = new Image();
      tmp.onload = () => {
        imgEl.src = src;
        imgEl.alt = alt;
        imgEl.classList.remove('lb-loading');
      };
      tmp.src = src;

      const hasPrev = images.length > 1;
      prevBtn.hidden = !hasPrev;
      nextBtn.hidden = !hasPrev;
      counter.hidden = images.length <= 1;
      counter.textContent = `${current + 1} / ${images.length}`;
    }

    function open(index) {
      show(index);
      overlay.classList.add('lb-open');
      requestAnimationFrame(() => overlay.classList.add('lb-visible'));
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function close() {
      overlay.classList.remove('lb-visible');
      overlay.addEventListener('transitionend', () => {
        overlay.classList.remove('lb-open');
        document.body.style.overflow = '';
      }, { once: true });
    }

    // Attach click handlers to all images
    images.forEach((img, i) => {
      const link = img.parentElement;
      link.addEventListener('click', e => {
        e.preventDefault();
        open(i);
      });
      link.style.cursor = 'zoom-in';
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', e => { e.stopPropagation(); show(current - 1); });
    nextBtn.addEventListener('click', e => { e.stopPropagation(); show(current + 1); });

    // Close on backdrop click
    overlay.addEventListener('click', e => {
      if (e.target === overlay) close();
    });

    // Keyboard navigation
    document.addEventListener('keydown', e => {
      if (!overlay.classList.contains('lb-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  }

  // Initialize on all .rte blocks within article content
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.article-template .rte').forEach(init);
  });
})();
